import { Formik } from 'formik';
import { useEmailsDirectory } from './context/EmailsDirProvider';
import EmailEntryForm from './EmailEntryForm';

const EmailEntryFormik = () => {
    const { editing, save, validate } = useEmailsDirectory();
    if (!editing) return null;
    return (
        <Formik
            key={editing === 'new' ? 'new' : editing.ID}
            initialValues={editing === 'new' ? { name: '', email: '', isPublic: false } : { name: editing.name, email: editing.email, isPublic: editing.isPublic }}
            validate={validate}
            validateOnBlur={false}
            onSubmit={save}
        >
            <EmailEntryForm />
        </Formik>
    );
};

export default EmailEntryFormik;
